(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define(["vue"], factory);
	else if(typeof exports === 'object')
		exports["MobileTuwen"] = factory(require("vue"));
	else
		root["PolyvIRScene"] = root["PolyvIRScene"] || {}, root["PolyvIRScene"]["MobileTuwen"] = factory(root["Vue"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__116__) {
return 